import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import TechnicalSidebar from './TechnicalSidebar';

function IPChart() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 bg-light mt-5" id="ip-chart">
      <div className="container">
        <div className="row">
          {/* Main Content */}
          <div className="col-lg-9 col-md-8 col-12 mb-4" data-aos="fade-up">
            <div className="text-center mb-4">
              <h2 className="fw-bold">IP Ratings Explained</h2>
              <p className="text-muted">
                Understanding Ingress Protection (IP) standards for solid objects and liquids.
              </p>
            </div>

            {/* First Digit */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-primary">1. First Digit (0–6): Protection Against Solid Objects</h4>
              <p><strong>0:</strong> No protection.</p>
              <p><strong>1:</strong> Protected against objects &gt; 50 mm (e.g., hands).</p>
              <p><strong>2:</strong> Protected against objects &gt; 12.5 mm (e.g., fingers).</p>
              <p><strong>3:</strong> Protected against objects &gt; 2.5 mm (e.g., tools).</p>
              <p><strong>4:</strong> Protected against objects &gt; 1 mm (e.g., wires).</p>
              <p><strong>5:</strong> Dust-protected (limited ingress permitted).</p>
              <p><strong>6:</strong> Dust-tight (no ingress of dust).</p>
            </div>

            {/* Second Digit */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-success">2. Second Digit (0–9): Protection Against Moisture</h4>
              <p><strong>0:</strong> No protection.</p>
              <p><strong>1:</strong> Protected against vertically falling drops of water (e.g., condensation).</p>
              <p><strong>2:</strong> Protected against water drops falling at an angle up to 15° from vertical.</p>
              <p><strong>3:</strong> Protected against spraying water (up to 60° from vertical).</p>
              <p><strong>4:</strong> Protected against splashing water from any direction.</p>
              <p><strong>5:</strong> Protected against water jets from any direction.</p>
              <p><strong>6:</strong> Protected against heavy seas or powerful water jets.</p>
              <p><strong>7:</strong> Protected against immersion in water up to 1 meter for 30 minutes.</p>
              <p><strong>8:</strong> Protected against immersion beyond 1 meter.</p>
              <p><strong>9:</strong> Protected against high-pressure and high-temperature water jets.</p>
            </div>

            {/* Examples */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-dark">Examples of IP Ratings</h4>
              <p><strong>IP65:</strong> Dust-tight and protected against water jets.</p>
              <p><strong>IP67:</strong> Dust-tight and protected against immersion in water up to 1 meter for 30 minutes.</p>
              <p><strong>IP68:</strong> Dust-tight and protected against continuous immersion in water, typically beyond 1 meter.</p>
            </div>

            {/* Importance */}
            <div className="p-4 bg-white border-start border-4 border-primary rounded" data-aos="fade-up">
              <h5 className="text-dark fw-semibold">Importance of IP Ratings</h5>
              <p className="mb-0 text-muted">
                IP ratings are crucial in selecting equipment for various environments, particularly in electrical and electronic applications.
                Understanding the IP rating helps ensure that the right equipment is used in the right settings,
                enhancing reliability and safety by preventing failure due to exposure to dust and moisture.
              </p>
            </div>
          </div>

          {/* Sidebar */}
          <TechnicalSidebar />
        </div>
      </div>
    </section>
  );
}

export default IPChart;
